export const defaultFilters = [
  {
    id: 25923527593,
    name: "Domestic Sport",
    items: [
      {
        field: "league",
        operator: "isAnyOf",
        id: 87947,
        value: ["AFL", "NRL", "NBL", "Australian A-League Men"],
        fromInput: ":r2e:",
      },
    ],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "48",
    selectedSport: null,
    selectedBookmakers: [],

    sortModel: [
      {
        field: "ev",
        sort: "asc",
      },
    ],
  },
  {
    id: 7238243734,
    name: "American Sport",
    items: [
      {
        field: "league",
        operator: "isAnyOf",
        id: 87947,
        value: [
          "NFL",
          "NHL",
          "NBA",
          "NFL Preseason Matches",
          "Major League Baseball",
        ],
        fromInput: ":r2e:",
      },
    ],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "48",
    selectedSport: null,
    selectedBookmakers: [],
  },
  {
    id: 72384533733,
    name: "Major Soccer Leagues",
    items: [
      {
        field: "league",
        operator: "isAnyOf",
        id: 87947,
        value: [
          "English Premier League",
          "Spanish La Liga",
          "German Bundesliga",
          "Italian Serie A",
          "Australian A-League Men",
          "UEFA Champions League",
          "UEFA Europa League Qualifiers",
          "UEFA Europa Conference Qualifiers",
          "UEFA Europa League",
          "UEFA Europa Conference",
        ],
        fromInput: ":r2e:",
      },
    ],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "48",
    selectedSport: null,
    selectedBookmakers: [],
  },
  {
    id: 1724574365902,
    name: "Events < 24hrs",
    items: [],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "24",
    selectedSport: null,
    selectedBookmakers: [],
  },
  {
    id: 1724574390775,
    name: "Events < 3 days",
    items: [],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "72",
    selectedSport: null,
    selectedBookmakers: [],
  },
  {
    id: 1724574412520,
    name: "Events < 7 days",
    items: [],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "168",
    selectedSport: null,
    selectedBookmakers: [],
  },
  {
    id: 1724574306893,
    name: "Non-Rails Bookies",
    items: [],
    maxOdds: "10",
    bookieCount: "3",
    hoursToEvent: "48",
    selectedSport: null,
    selectedBookmakers: [
      "Bet365",
      "Betr",
      "BetRight",
      "Bluebet",
      "Dabble",
      "Ladbrokes",
      "Neds",
      "Picklebet",
      "Pointsbet",
      "Tab",
      "Tab Touch",
      "UniBet",
      "BetKings",
      "Sportsbet",
      "SXBet",
      "TabNz",
      "TopSport",
    ],
  },
  {
    id: 1724574467778,
    name: "High Confidence (10+ Count)",
    items: [],
    maxOdds: "10",
    bookieCount: "10",
    hoursToEvent: "48",
    selectedSport: null,
    selectedBookmakers: [],
  },
];
